var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInvite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "18px",
    viewBox: "0 0 20 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 30") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Pool-Memberlist",
    transform: "translate(-1135.000000, -608.000000)",
    fill: "#14376f",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(130.000000, 392.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-26",
    transform: "translate(30.000000, 181.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-13",
    transform: "translate(975.000000, 35.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-30",
    transform: "translate(0.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.7760149,9.25519553 C11.6449907,8.47307263 12.166406,7.3433892 12.166406,6.08320298 C12.166406,3.69333333 10.2110987,1.73795158 7.82115456,1.73795158 C5.43121043,1.73795158 3.47590317,3.69325885 3.47590317,6.08320298 C3.47590317,7.34324022 3.99731844,8.47307263 4.86629423,9.25519553 C1.99865922,10.4283799 -1.270244e-14,13.2525885 -1.270244e-14,16.5114339 C-1.270244e-14,16.9893482 0.391061453,17.3804097 0.868975791,17.3804097 C1.34689013,17.3804097 1.73795158,16.9893482 1.73795158,16.5114339 C1.73795158,13.1657356 4.47538175,10.4283799 7.82100559,10.4283799 C11.1666294,10.4283799 13.9040596,13.1658101 13.9040596,16.5114339 C13.9040596,16.9893482 14.295121,17.3804097 14.7730354,17.3804097 C15.2509497,17.3804097 15.6420112,16.9893482 15.6420112,16.5114339 C15.6423021,13.2525885 13.6436499,10.4283799 10.7757169,9.25519553 L10.7760149,9.25519553 Z M5.21400372,6.08320298 C5.21400372,4.64931099 6.38718808,3.47612663 7.82108007,3.47612663 C9.25497207,3.47612663 10.4281564,4.64931099 10.4281564,6.08320298 C10.4281564,7.51709497 9.25497207,8.69027933 7.82108007,8.69027933 C6.38718808,8.69027933 5.21400372,7.51709497 5.21400372,6.08320298 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.987564,3.47605214 C19.987564,3.95396648 19.5964991,4.34502793 19.1185847,4.34502793 L17.3804842,4.34502793 L17.3804842,6.08312849 C17.3804842,6.56104283 16.9894227,6.95210428 16.5115084,6.95210428 C16.033594,6.95210428 15.6425326,6.56104283 15.6425326,6.08312849 L15.6425326,4.34502793 L13.904432,4.34502793 C13.4265177,4.34502793 13.0354562,3.95396648 13.0354562,3.47605214 C13.0354562,2.9981378 13.4265177,2.60707635 13.904432,2.60707635 L15.6425326,2.60707635 L15.6423871,0.868975791 C15.6423871,0.391061453 16.0334485,-5.50439065e-14 16.5113629,-5.50439065e-14 C16.9892772,-5.50439065e-14 17.3803387,0.391061453 17.3803387,0.868975791 L17.3803387,2.60707635 L19.1184392,2.60707635 C19.5965025,2.60707635 19.987564,2.9981378 19.987564,3.47605214 L19.987564,3.47605214 Z",
    id: "Path"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvite);
export default __webpack_public_path__ + "static/media/invite.b0ba42030f477ae5220359264c9eb8dc.svg";
export { ForwardRef as ReactComponent };